export default __webpack_public_path__ + "static/media/audioEquipment.35983299.jpg";